import axios from 'axios';

export default {
  fetchDenominations(params){
    return axios.get(process.env.VUE_APP_PORTAUS_API_URL+":"+process.env.VUE_APP_PORTAUS_API_PORT+"/api/latest/admin/denominations", {params})
      .then(results=>{
        return results.data;
      })
  }
}
